import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { throttle } from 'lodash'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import configureStore from './redux/configure-store'
import * as reduxState from './redux/state'

// load state from storage if we can
const persistedState = reduxState.loadState()
const store = configureStore(persistedState)

store.subscribe(
  throttle(() => {
    reduxState.saveState(store.getState())
  }, 1000)
)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// can read about this in the create react app docs but basically
// won't work unless I use https
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js